<template>
  <v-row justify="center" dense>

    <v-col cols="12">

      <v-row justify="center" dense>

        <v-col cols="12">
          <location-history
              v-if="$store.getters.orderSystem.locationHistoryService.hasLocationHistory && showLocation === false && !location.address"
              @locationSelected="locationSelected"
              @locationNew="locationNew"
          ></location-history>
          <template v-else>
            <v-card>
              <v-card-text>
                <location-form
                    v-model="location"
                    enable-floor enable-apartment
                    enable-map
                    map-height="200px"
                    :address-sm-col="12"
                    :apartment-sm-col="6"
                    :floor-sm-col="6"
                    :map-sm-col="12"
                    @clear="clear"
                    :address-first="false"
                    :enable-locality-combobox="true"
                ></location-form>
              </v-card-text>
            </v-card>

          </template>

        </v-col>

      </v-row>
    </v-col>

    <v-col v-if="$store.getters.orderSystem.order.delivery.cost && $store.getters.orderSystem.order.delivery.distance"
           cols="12">
      <v-alert v-if="isDeliverable" class="text-left align-center" dense type="info">
        Costo de envío: <b>${{
          $store.getters.orderSystem.order.delivery.cost
        }} </b>({{ $store.getters.orderSystem.order.delivery.distance }}Km)
      </v-alert>
      <v-alert v-else class="text-left align-center" dense type="info">
        Distancia: {{ $store.getters.orderSystem.order.delivery.distance }} Km
      </v-alert>

    </v-col>


    <!--#[EN HORA]-->
    <v-col v-if="isCalendarActive && location.address && !loadingDeliveryCost" cols="12">
      <v-row justify="center" dense>

        <!--#[EN ZONA] => LOADING -->
        <v-col v-if="loadingInZone" cols="12">
          <loading text="maps.zone.determiningZone"></loading>
        </v-col>

        <!--#[isDeliverable] => TRUE -->
        <v-col v-else-if="(isDeliverable === true) && loadingInZone === false"
               cols="12"
        >
          <schedule-as-soon-as-posible
              v-model="time"
              enable-delivery-time
          />

        </v-col>

        <!--#[isDeliverable] => FALSE -->
        <v-col v-else-if="isDeliverable === false && loadingInZone === false"
               cols="12"
        >
          <v-alert
              type="warning"
              class="text-left"
              rounded
              text
              outlined
              prominent
          >
            {{ getMessageOutOfZone }}
          </v-alert>
          <v-btn
              class="green white--text"
              :href="getWhatsappLink"
              target="_blank"
          >
            <v-icon left>contact_support</v-icon>
            Whatsapp
          </v-btn>
        </v-col>

      </v-row>
    </v-col>

    <!--#[FUERA DE HORA] => FALSE -->

    <v-col v-if="!isCalendarActive && location.address && !loadingDeliveryCost" cols="12">
      <v-row justify="center" dense>

        <!--#[isDeliverable] => LOADING -->
        <v-col v-if="loadingInZone" cols="12">
          <loading text="maps.zone.determiningZone"></loading>
        </v-col>

        <!--#[isDeliverable] => TRUE -->
        <v-col v-else-if="(isDeliverable === true ) && loadingInZone === false" cols="12"
        >

          <!--#[isDeliverable] => FUERA DE HORA -->
          <v-alert v-if="!isCalendarActive"
                   type="warning"
                   class="text-left"
                   rounded
                   text
                   outlined
                   prominent
          >
            {{ getMessageOutOfTime }}
          </v-alert>

          <schedule-time-combobox v-model="time" delivery-mode></schedule-time-combobox>

        </v-col>

        <!--#[FUERA  ZONA] => FALSE -->
        <v-col v-else-if=" isDeliverable === false && loadingInZone === false"
               cols="12"
        >
          <v-alert
              type="warning"
              class="text-left"
              rounded
              text
              outlined
              prominent
          >
            {{ getMessageOutOfZone }}
          </v-alert>
          <v-btn
              class="green white--text"
              :href="getWhatsappLink"
              target="_blank"
          >
            <v-icon left>contact_support</v-icon>
            Whatsapp
          </v-btn>
        </v-col>

      </v-row>
    </v-col>




  </v-row>
</template>

<script>
import { Loading} from "@dracul/common-frontend"
import LocationForm from "@/modules/maps/components/LocationForm/LocationForm";
import LocationIsInZone from "@/modules/maps/mixins/LocationIsInZone";
import LocationHistory from "@/modules/delivery/components-core/customer/LocationHistory/LocationHistory";
import OrderProvider from "@/modules/delivery/providers/OrderProvider";
import ScheduleTimeCombobox
  from "@/modules/delivery/components-core/shared/ScheduleTimeCombobox/ScheduleTimeCombobox.vue";
import ScheduleAsSoonAsPosible
  from "@/modules/delivery/components-core/shared/ScheduleAsSoonAsPosible/ScheduleAsSoonAsPosible.vue";

const AS_SON_AS_POSIBLE = 'AS_SON_AS_POSIBLE'
const SCHEDULED = 'SCHEDULED'
export default {
  name: "CustomerOrderModeDelivery",
  components: {
    ScheduleAsSoonAsPosible,
    ScheduleTimeCombobox,
    LocationHistory,
    LocationForm,
    Loading
  },
  mixins: [ LocationIsInZone],
  data() {
    return {
      showLocation: false,
      loadingDeliveryCost: false
    }
  },
  created() {
    //this.recoveryLastLocation()
  },
  mounted() {
    this.determineZone(this.location)
    this.determineOrderDeliveryCost()
    if (this.location.address) {
      this.showLocation = true
    }
    this.determineTimeMode()
  },
  computed: {
    isCalendarActive(){
      return this.$store.getters.orderSystem.isCalendarDeliveryActive()
    },
    hasAdressNumber() {
      if (/[0-9]+/.test(this.location.address)) {
        return true
      } else {
        return false
      }
    },
    getDurationMin() {
      return this.duration ? this.duration / 60 : null
    },
    isDeliverable() {
      if (this.$store.getters.orderSystem.order.delivery.distance < this.$store.getters.getSettingValue('maxKmForDelivery')) {
        return true
      } else {
        return false
      }
    },
    location: {
      get() {
        return this.$store.getters.orderSystem.order.location
      },
      set(val) {
        this.showLocation = true
        this.setDeliveryTime(null)
        this.$store.commit('orderLocation', val)
        this.$store.commit('addLocationHistory', val)
        this.determineZone(val)
        this.determineOrderDeliveryCost()
      }
    },
    getMessageOutOfTime() {
      return this.$store.getters.getSettingValue('MessageOutOfTime')
    },
    getMessageOutOfZone() {
      return this.$store.getters.getSettingValue('MessageOutOfZone')
    },
    getWhatsappNumber() {
      return this.$store.getters.getSettingValue('WhatsappNumber')
    },
    getWhatsappLink() {
      return 'https://api.whatsapp.com/send?phone=' + this.getWhatsappNumber
    },
    isAsSonAsPosible() {
      return this.$store.getters.orderSystem.order.isAsSoonAsPosible
    },
    isScheduled() {
      return this.$store.getters.orderSystem.order.isScheduled
    },
    time: {
      get() {
        return this.$store.getters.orderSystem.order.delivery.time
      },
      set(v) {
        this.setDeliveryTime(v)
      }
    }
  },

  methods: {
    determineOrderDeliveryCost() {
      this.loadingDeliveryCost = true
      let branchId = this.$store.getters.branchSelected.id
      let destination = this.$store.getters.orderSystem.order.location.address
      let destinationPlaceId = this.$store.getters.orderSystem.order.location.place_id
      if (branchId && destination) {
        OrderProvider.orderDeliveryCost(branchId, destination, destinationPlaceId)
            .then(r => {
              this.$store.commit("orderDeliveryCost", r.data.orderDeliveryCost.cost)
              this.$store.commit("orderDeliveryDistance", r.data.orderDeliveryCost.distanceKm)
              this.$store.commit("orderDeliveryLongDistance", r.data.orderDeliveryCost.longDistance)
            })
            .catch(e => {
              console.error("determineOrderDeliveryCost", e)
            })
            .finally(() => this.loadingDeliveryCost = false)
      }
    },
    determineTimeMode() {
      if (this.$store.getters.orderSystem.isCalendarDeliveryActive()) {
        this.asSonAsPosible()
      } else {
        this.scheduled()
      }
    },
    locationSelected(location) {
      this.location = Object.assign({}, location)
      this.showLocation = true
    },
    locationNew() {
      this.$store.commit('clearOrderLocation')
      this.showLocation = true
    },
    clear() {
      this.clearZone()
      this.setDeliveryTime(null)
      this.$store.commit('orderDeliveryCost', null)
      this.$store.commit('orderDeliveryDistance', null)
    },
    recoveryLastLocation() {
      this.$store.commit('recoveryLastLocation')
    },
    determineZone(location) {
      this.findLocationZone(location)
    },
    isBusinessHours() {
      return true
    },
    asSonAsPosible() {
      this.$store.commit('orderTimeMode', AS_SON_AS_POSIBLE)
    },
    scheduled() {
      this.$store.commit('orderTimeMode', SCHEDULED)
    },
    setDeliveryTime(val) {
      this.$store.commit('orderTime', val)
    }
  }
}
</script>

<style scoped>

</style>
